import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {DownOutlined, UpOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import _ from 'lodash';

import labels from '../../../../config/labels.json'
import {ILabel} from '../../../../config/lebels-type';
import {STORY} from '../../../../config/routes';
import {Card} from '../../Card';
import {IStory} from '../type';

import cls from './Story.module.scss'


export const WidgetStory = ({identifier, content}: IStory) => {

    const {t} = useTranslation();
    const navigate = useNavigate()
    const labelGroup = _.filter(labels, (label: ILabel) => label.identifier === identifier)[0];
    const [open, setOpen] = useState<boolean>(content && content.length < 4);

    const openable = content.length > 3

    const displayContent = open ? content : _.slice(content, 0, 2)

    return (
        <Card title={t(labelGroup.label)} green={true} icon={labelGroup.icon}>
            {_.map(displayContent, line => {
                const labelLine = _.filter(labels, (label: ILabel) => label.identifier === line)[0]?.label;
                return (
                    <div key={line} className={cls.line} onClick={() => navigate(STORY, {state:{identifier: line}})}>{t(labelLine!)}</div>
                )
            })}

            {openable && (open ?
                <Button type={'link'} icon={<UpOutlined/>} onClick={() => setOpen(false)}>{t('Hide')}</Button>
            :
                <Button type={'link'} icon={<DownOutlined/>} onClick={() => setOpen(true)}>{t('{{x}} more...', {x: content.length - 2})}</Button>
            )}
        </Card>
    )
}